import { Button } from '@/components/ui/button';
import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { ResellType } from '@/models/types';
import { ArrowRightLeft } from 'lucide-react';
import { RESALE_TYPE_OPTIONS_MAP } from './resell-type-selector-combobox';

export const ResellIcon = ({ className }: { className?: string }) => {
  return <ArrowRightLeft className={cn('h-3.5 w-3.5', className)} />;
};

export const ResellTypeBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  useAbbreviation = false,
}: {
  value: ResellType;
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  useAbbreviation?: boolean;
}) => {
  return (
    <Button
      variant="ghost"
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {value === null && (
        <>
          <PDKEmptyValueIcon className="h-3.5 w-3.5" />
          <p className="rounded text-xs  text-gray-600">No Resell Type</p>
        </>
      )}
      {RESALE_TYPE_OPTIONS_MAP.map((option) => {
        if (option.value === value) {
          return <div key={option.value}>{option.icon}</div>;
        }
      })}

      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {useAbbreviation
            ? RESALE_TYPE_OPTIONS_MAP.find((option) => option.value === value)
                ?.abbreviation
            : RESALE_TYPE_OPTIONS_MAP.find((option) => option.value === value)
                ?.label}
        </p>
      )}
    </Button>
  );
};
